import {
    Backdrop,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Modal,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";


import { getDoctorTypeDropDown, postBloodGroupDropdown, postDoctorDropdown, postgetAntibioticsDropdown, preOperativeNotessaveOrUpdate } from "../../../services/otDetailsServices/OtDetailsServices";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import InputField from "../../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import { errorAlert, successAlert } from "../../../../common/components/Toasts/CustomToasts";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import TimePickerFieldNew from "../../../../common/components/FormFields/TimePickerFieldNew";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import { bloodGroupDropdown } from "../../../../masters/services/referalDoctor/ReferalDoctorServices";
const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "90vh",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "1px solid gray",
    borderRadius: 2,
    boxShadow: 20,
    p: 3,
};

export default function PreOperativeNotesModel(props) {

    const [openPost, setOpenPost] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [dataResult, setDataResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [patientData, setPatientData] = useState({});
    const [fitnessOptions, setfitnessOptions] = useState([]);
    const [doctortypeOptions, setdoctortypeOptions] = useState([]);
    const [anesthetistOptions, setAnesthetistOptions] = useState([]);
    const [handoverToOptions, setHandoverToOptions] = useState([]);
    const [handoverByOptions, setHandoverByOptions] = useState([]);
    const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
    const [surgeonOptions, setSurgeonOptions] = useState([]);

    const [isUpdate, setIsUpdate] = useState(false);

    const defaultValues = {
        surgery: "",
        serology: "",
        shiftOutOrder: null,
        height: "",
        weight: "",
        officePermission: "Done",
        pac: "Done",
        fitnessDoctor: null,
        doctortype: null,
        nbmTime: null,
        nbm: "",
        surgeryConsent: "",
        highRiskConsent: "",
        anaesthesiaConsent: "",
        otherConsent: "",
        serologyDate: null,
        serologyTime: null,
        allergy: "",
        skinIssue: "",
        partPreparation: "",
        siteMarking: "",
        preOpMedication: "",
        antibiotic: "",
        antibioticTime: null,
        antibioticNA: false,
        icuBedNo: "",
        icuBedNA: false,
        bloodGroup: null,
        bloodProducts: "",
        handoverRemark: "",
        handoverTo: null,
        handoverBy: null,
    };

    const {
        control,
        watch,
        setValue,
        handleSubmit,
        getValues,
        reset,
    } = useForm({
        defaultValues,
    });

    const antibioticNA = watch("antibioticNA");
    const icuBedNA = watch("icuBedNA");

    const handleOpenPost = () => {
        setOpenPost(true);
    };
    const handleClosePost = () => {
        setOpenPost(false);
    };


    const getSurgeonDropdown = async (value = "") => {
        console.log("API Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);
            setSurgeonOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getHandoverToDropdown = async (value = "") => {
        console.log("Handover To Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setHandoverToOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getHandoverByDropdown = async (value = "") => {
        console.log("Handover By Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setHandoverByOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getBloodGroupDropdown = async () => {
        try {
            const response = await bloodGroupDropdown("");

            console.log(
                "Blood Group API:",
                response.data.result
            );

            setBloodGroupOptions(
                response?.data?.result || []
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getDoctorTypeDropdown = async (value = "") => {
        if (!value?.trim()) return;

        try {
            const response = await getDoctorTypeDropDown(value);
            setdoctortypeOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getTimePayload = (time) => {
        if (!time) return null;

        const timeObj = new Date(time);

        return `${String(timeObj.getHours()).padStart(2, "0")}:${String(
            timeObj.getMinutes()
        ).padStart(2, "0")}:${String(timeObj.getSeconds()).padStart(2, "0")}`;
    };

    const handleSubmitClick = (data) => {
        setPendingData(data);
        setOpenPost(true);
    };

    const addRecord = async () => {
        try {
            setLoading(true);

            const data = pendingData;

            const payload = {
                id: isUpdate ? patientData?.id : null,

                admissionId: props?.admissionId || 0,
                otHeaderId: props?.otHeaderId || 0,

                surgery: data?.surgery || "",

                surgeonId: data?.shiftOutOrder?.id || 0,

                height: data?.height || "",
                weight: data?.weight || "",

                officePermission: data?.officePermission || "",

                pac: data?.pac || "",

                fitness: data?.fitness || "",

                nbmTime: getTimePayload(data?.nbmTime),

                nbmRemark: data?.nbm || "",

                surgeryConsent: data?.surgeryConsent || "",

                highRiskConsent: data?.highRiskConsent || "",

                anaesthesiaConsent: data?.anaesthesiaConsent || "",

                otherConsent: data?.otherConsent || "",

                serology: data?.serology || "",

                serologyDate: data?.serologyDate
                    ? dayjs(data.serologyDate).format("YYYY-MM-DD")
                    : null,

                serologyTime: getTimePayload(data?.serologyTime),

                allergy: data?.allergy || "",

                skinIssue: data?.skinIssue || "",

                partPreparation: data?.partPreparation || "",

                siteMarking: data?.siteMarking || "",

                preOpMedication: data?.preOpMedication || "",

                antibiotic: data?.antibiotic || "",

                antibioticTime: getTimePayload(data?.antibioticTime),

                antibioticNA: data?.antibioticNA || false,

                icuBed: data?.icuBedNo || "",

                icuBed: data?.icuBedNo || "",

                icuBedNA: data?.icuBedNA || false,

                bloodGroup:
                    data?.bloodGroup?.label ||
                    data?.bloodGroup ||
                    "",

                bloodProducts: data?.bloodProducts || "",

                remark: data?.handoverRemark || "",

                handoverToId: data?.handoverTo?.id || 0,

                handoverById: data?.handoverBy?.id || 0,

                ...(isUpdate
                    ? {
                        updatedBy: 1,
                        updatedDateTime: new Date().toISOString(),
                    }
                    : {
                        addedBy: 1,
                        updatedBy: 1,
                        addedDateTime: new Date().toISOString(),
                        updatedDateTime: new Date().toISOString(),
                    }),
            };

            console.log("PAYLOAD", payload);

            const response =
                await preOperativeNotessaveOrUpdate(
                    payload
                );

            successAlert(
                response?.data?.message ||
                "Saved Successfully"
            );

            reset(defaultValues);

            handleClosePost();
            // props.handleClose();

        } catch (error) {

            errorAlert(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.patientData) {
            setPatientData(props.patientData);
        }
    }, [props.patientData]);

    useEffect(() => {
        if (props.patientData?.id > 0) {

            setPatientData(props.patientData);
            setIsUpdate(true);

            reset({
                surgery: props.patientData?.surgery || "",

                shiftOutOrder: props.patientData?.surgeonId
                    ? {
                        id: props.patientData.surgeonId,
                        label: props.patientData.surgeonName,
                    }
                    : null,

                height: props.patientData?.height || "",

                weight: props.patientData?.weight || "",

                officePermission:
                    props.patientData?.officePermission || "Done",

                pac: props.patientData?.pac || "Done",

                fitness: props.patientData?.fitness || "",

                nbmTime: props.patientData?.nbmTime
                    ? new Date(`2000-01-01T${props.patientData.nbmTime}`)
                    : null,

                nbm: props.patientData?.nbmRemark || "",

                surgeryConsent:
                    props.patientData?.surgeryConsent || "",

                highRiskConsent:
                    props.patientData?.highRiskConsent || "",

                anaesthesiaConsent:
                    props.patientData?.anaesthesiaConsent || "",

                otherConsent:
                    props.patientData?.otherConsent || "",

                serology:
                    props.patientData?.serology || "",

                serologyDate:
                    props.patientData?.serologyDate
                        ? new Date(props.patientData.serologyDate)
                        : null,

                serologyTime: props.patientData?.serologyTime
                    ? new Date(`2000-01-01T${props.patientData.serologyTime}`)
                    : null,

                allergy:
                    props.patientData?.allergy || "",

                skinIssue:
                    props.patientData?.skinIssue || "",

                partPreparation:
                    props.patientData?.partPreparation || "",

                siteMarking:
                    props.patientData?.siteMarking || "",

                preOpMedication:
                    props.patientData?.preOpMedication || "",

                antibiotic:
                    props.patientData?.antibiotic || "",

                antibioticTime:
                    props.patientData?.antibioticTime
                        ? new Date(
                            `2000-01-01T${props.patientData.antibioticTime}`
                        )
                        : null,

                antibioticNA:
                    props.patientData?.antibioticNA || false,


                icuBedNA:
                    props.patientData?.icuBedNA || false,


                icuBedNo:
                    props.patientData?.icuBed || "",

                bloodGroup: null,

                bloodProducts:
                    props.patientData?.bloodProducts || "",

                handoverRemark:
                    props.patientData?.remark || "",

                handoverTo:
                    props.patientData?.handoverToId
                        ? {
                            id: props.patientData.handoverToId,
                            label:
                                props.patientData.handoverToName,
                        }
                        : null,

                handoverBy:
                    props.patientData?.handoverById
                        ? {
                            id: props.patientData.handoverById,
                            label:
                                props.patientData.handoverByName,
                        }
                        : null,
            });

        } else {

            setPatientData({});
            setIsUpdate(false);
            reset(defaultValues);
        }

    }, [props.patientData, reset]);

    useEffect(() => {
        if (antibioticNA) {
            setValue("antibiotic", "");
            setValue("antibioticTime", null);
        }
    }, [antibioticNA, setValue]);

    useEffect(() => {
        if (icuBedNA) {
            setValue("icuBedNo", "");
        }
    }, [icuBedNA, setValue]);

    useEffect(() => {
        getBloodGroupDropdown();
    }, []);

    useEffect(() => {
        if (
            props.patientData?.bloodGroup &&
            bloodGroupOptions.length > 0
        ) {
            const selectedBloodGroup =
                bloodGroupOptions.find(
                    item =>
                        item.label ===
                        props.patientData.bloodGroup
                );

            if (selectedBloodGroup) {
                setValue(
                    "bloodGroup",
                    selectedBloodGroup
                );
            }
        }
    }, [
        props.patientData?.bloodGroup,
        bloodGroupOptions,
        setValue,
    ]);

    useEffect(() => {
        if (getValues("icuBedNo")) {
            setValue("icuBedNA", false);
        }
    }, [watch("icuBedNo")]);

    return (
        <div>
            <Box
                sx={{
                    mt: 2,
                    p: 3,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    backgroundColor: "#fff",
                }}
            >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                    <div className="border rounded-md bg-white">
                        <div className="bg-[#adfde8] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Patient & Surgery Details
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Surgery</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="surgery"
                                    label="Surgery"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Surgeon</Typography>
                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="shiftOutOrder"
                                    placeholder="Shift Out Order By Surgeon"
                                    label="Shift Out Order By Surgeon"
                                    options={surgeonOptions}
                                    isClearable={true}
                                    searchIcon={true}
                                    dataArray={surgeonOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        console.log("Surgeon:", value);
                                        getSurgeonDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />

                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Height</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="height"
                                    label="Height (Feet/Cm)"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Weight</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="weight"
                                    label="Weight (Kg)"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#ffd6d6] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Pre Operative Checklist
                        </div>

                        <div className="space-y-3 px-3 py-2">


                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Office Permission
                                </Typography>

                                <Typography>:</Typography>

                                <Controller
                                    name="officePermission"
                                    control={control}
                                    defaultValue="Done"
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel
                                                value="Done"
                                                control={<Radio size="small" />}
                                                label="Done"
                                            />
                                            <FormControlLabel
                                                value="Not Done"
                                                control={<Radio size="small" />}
                                                label="Not Done"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>


                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">PAC</Typography>

                                <Typography>:</Typography>

                                <Controller
                                    name="pac"
                                    control={control}
                                    defaultValue="Done"
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel
                                                value="Done"
                                                control={<Radio size="small" />}
                                                label="Done"
                                            />
                                            <FormControlLabel
                                                value="Not Done"
                                                control={<Radio size="small" />}
                                                label="Not Done"
                                            />
                                            <FormControlLabel
                                                value="NA"
                                                control={<Radio size="small" />}
                                                label="Not Applicable"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>


                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Fitness</Typography>

                                <Typography>:</Typography>

                                <Controller
                                    name="fitness"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div className="flex flex-wrap gap-3">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={field.value === "Cardiac"}
                                                        onChange={() =>
                                                            field.onChange(
                                                                field.value === "Cardiac"
                                                                    ? ""
                                                                    : "Cardiac"
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Cardiac"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={field.value === "Physician"}
                                                        onChange={() =>
                                                            field.onChange(
                                                                field.value === "Physician"
                                                                    ? ""
                                                                    : "Physician"
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Physician"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={field.value === "Other"}
                                                        onChange={() =>
                                                            field.onChange(
                                                                field.value === "Other"
                                                                    ? ""
                                                                    : "Other"
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Other"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={field.value === "NA"}
                                                        onChange={() =>
                                                            field.onChange(
                                                                field.value === "NA"
                                                                    ? ""
                                                                    : "NA"
                                                            )
                                                        }
                                                    />
                                                }
                                                label="NA"
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-[175px_20px_1fr] items-start gap-2">
                                <Typography fontWeight="600" className="pt-2">
                                    NBM
                                </Typography>

                                <Typography className="pt-2">:</Typography>

                                <div className="grid grid-cols-2 gap-2">
                                    <div className=" origin-top">
                                        <TimePickerFieldNew
                                            control={control}
                                            name="nbmTime"
                                            label="NBM Time"
                                            textFieldProps={{
                                                size: "small",
                                                fullWidth: true,
                                            }}
                                        />
                                    </div>

                                    <div className="flex-1">
                                        <InputField
                                            control={control}
                                            name="nbm"
                                            label="NBM"
                                            size="small"
                                            fullWidth
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                    <div className="border rounded-md bg-white">
                        <div className="bg-[#ffe5c7] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Consent
                        </div>

                        <div className="space-y-3 px-3 py-2">

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Surgery Consent
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="surgeryConsent"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel
                                                value="YES"
                                                control={<Radio size="small" />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="NO"
                                                control={<Radio size="small" />}
                                                label="No"
                                            />
                                            <FormControlLabel
                                                value="NA"
                                                control={<Radio size="small" />}
                                                label="NA"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    High Risk Consent
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="highRiskConsent"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel value="YES" control={<Radio size="small" />} label="Yes" />
                                            <FormControlLabel value="NO" control={<Radio size="small" />} label="No" />
                                            <FormControlLabel value="NA" control={<Radio size="small" />} label="NA" />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Anaesthesia Consent
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="anaesthesiaConsent"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel value="YES" control={<Radio size="small" />} label="Yes" />
                                            <FormControlLabel value="NO" control={<Radio size="small" />} label="No" />
                                            <FormControlLabel value="NA" control={<Radio size="small" />} label="NA" />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Other Consent
                                </Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="otherConsent"
                                    label="Other Consent"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>


                    <div className="border rounded-md bg-white">
                        <div className="bg-[#cfe8ff] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Clinical Information
                        </div>

                        <div className="space-y-3 px-3 py-2">

                            <div className="grid grid-cols-[180px_20px_1fr] items-start gap-1">
                                <Typography fontWeight="600">
                                    Serology
                                </Typography>

                                <Typography>:</Typography>

                                <div className="grid grid-cols-3 gap-2 items-start">
                                    <InputField
                                        control={control}
                                        name="serology"
                                        label="Serology"
                                        size="small"
                                        fullWidth
                                    />

                                    <DatePickerField
                                        control={control}
                                        name="serologyDate"
                                        label="Serology Date"
                                        textFieldProps={{
                                            size: "small",
                                            fullWidth: true,
                                        }}
                                                                        inputFormat={"dd-MM-yyyy"}

                                    />

                                    <div className=" origin-top">
                                        <TimePickerFieldNew
                                            control={control}
                                            name="serologyTime"
                                            label="Serology Time"
                                            textFieldProps={{
                                                size: "small",
                                                fullWidth: true,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Allergy
                                </Typography>
                                <Typography>:</Typography>

                                <div className="-mt-4 py-3">
                                    <InputField
                                        control={control}
                                        name="allergy"
                                        label="Allergy"
                                        size="small"
                                        fullWidth
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Skin Issue
                                </Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="skinIssue"
                                    label="Skin Issue"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Part Preparation
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="partPreparation"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel value="DONE" control={<Radio size="small" />} label="Done" />
                                            <FormControlLabel value="NOT_DONE" control={<Radio size="small" />} label="Not Done" />
                                            <FormControlLabel value="NA" control={<Radio size="small" />} label="Not Applicable" />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Site Marking
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="siteMarking"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel value="DONE" control={<Radio size="small" />} label="Done" />
                                            <FormControlLabel value="NOT_DONE" control={<Radio size="small" />} label="Not Done" />
                                            <FormControlLabel value="NA" control={<Radio size="small" />} label="Not Applicable" />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                        </div>
                    </div>

                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                    <div className="border rounded-md bg-white">
                        <div className="bg-[#fec6d5] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Medication & Blood Details
                        </div>

                        <div className="space-y-3 px-3 py-2">

                            <div className="grid grid-cols-[180px_20px_1fr] items-start gap-1">
                                <Typography fontWeight="600">
                                    Pre OP Medication
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="preOpMedication"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Pre OP Medication"
                                            multiline
                                            rows={2}
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Antibiotics
                                </Typography>

                                <Typography>:</Typography>

                                <div className="flex flex-col sm:flex-row sm:items-center gap-1">

                                    <div className="flex-1">
                                        <InputField
                                            control={control}
                                            name="antibiotic"
                                            label="Antibiotic"
                                            size="small"
                                            fullWidth
                                            disabled={antibioticNA}
                                        />
                                    </div>

                                    <div className="w-[140px]">
                                        <TimePickerFieldNew
                                            control={control}
                                            name="antibioticTime"
                                            label="Time"
                                            disabled={antibioticNA}
                                            textFieldProps={{
                                                size: "small",
                                                fullWidth: true,
                                                disabled: antibioticNA,
                                            }}
                                        />
                                    </div>

                                    <Controller
                                        name="antibioticNA"
                                        control={control}
                                        render={({ field }) => (
                                            <FormControlLabel
                                                sx={{
                                                    m: 0,
                                                    ml: 0,
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "0.875rem",
                                                    },
                                                }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={field.value || false}
                                                        onChange={(e) =>
                                                            field.onChange(e.target.checked)
                                                        }
                                                    />
                                                }
                                                label="NA"
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    ICU Bed
                                </Typography>

                                <Typography>:</Typography>

                                <div className="flex flex-col sm:flex-row sm:items-center gap-1">

                                    <div className="flex-1">
                                        <InputField
                                            control={control}
                                            name="icuBedNo"
                                            label="Bed No"
                                            size="small"
                                            fullWidth
                                            disabled={icuBedNA}
                                        />
                                    </div>

                                    <Controller
                                        name="icuBedNA"
                                        control={control}
                                        render={({ field }) => (
                                            <FormControlLabel
                                                sx={{
                                                    m: 0,
                                                    ml: 0,
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "0.875rem",
                                                    },
                                                }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={field.value || false}
                                                        onChange={(e) =>
                                                            field.onChange(e.target.checked)
                                                        }
                                                    />
                                                }
                                                label="NA"
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Blood Group
                                </Typography>
                                <Typography>:</Typography>

                                <DropdownField
                                    control={control}
                                    name="bloodGroup"
                                    placeholder="Select Blood Group"
                                    label="Blood Group"
                                    options={bloodGroupOptions}
                                    dataArray={bloodGroupOptions}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Blood Products
                                </Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="bloodProducts"
                                    label="Blood Products"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#ebfead] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Handover Details
                        </div>

                        <div className="space-y-3 px-3 py-2">

                            <div className="grid grid-cols-[180px_20px_1fr] items-start gap-1">
                                <Typography fontWeight="600">
                                    Remark
                                </Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="handoverRemark"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Remark"
                                            multiline
                                            rows={2}
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                />
                            </div>


                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Handover To
                                </Typography>
                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="handoverTo"
                                    label="Handover To"
                                    placeholder="Handover To"
                                    searchIcon={true}
                                    options={handoverToOptions}
                                    isClearable={true}
                                    dataArray={handoverToOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getHandoverToDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>


                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Handover By
                                </Typography>
                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="handoverBy"
                                    label="Handover By"
                                    placeholder="Handover By"
                                    searchIcon={true}
                                    options={handoverByOptions}
                                    isClearable={true}
                                    dataArray={handoverByOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getHandoverByDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => reset()}
                        sx={{
                            textTransform: "none",
                        }}
                    >
                        Reset
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleSubmitClick)}
                        sx={{
                            backgroundColor: "#22c55e",
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: 500,
                            px: 2,
                        }}
                    >
                        {isUpdate ? "Update" : "Submit"}
                    </Button>
                </div>

            </Box>


            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 9999,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ConfirmationModal
                confirmationOpen={openPost}
                confirmationHandleClose={handleClosePost}
                confirmationSubmitFunc={addRecord}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure you want to submit this record ?"
                confirmationButtonMsg="Confirm"
            />
        </div >
    );
}